function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo, stateReload } from 'redux-ui-router';
import { NewWindow, SubscriberOrderTypeEnum } from 'invision-core';
import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import { fetchCodeTypes, fetchServiceAttributes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { MetadataCodeLoadedSelector, MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { OfferingMetadataByIdSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { hasAccess, hasReadAccess } from 'invision-core/src/components/security/permission.service';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import CustomerLocaleKeys from '../../../../locales/keys';
import { OVERRIDE_BILLING_EFFECTIVE_DATE, PAYMENT_ACTIVITY_VIEW_ACCESS } from '../../../../security.attributes';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { CurrentOrderIdSelector, CurrentCustomerIdSelector, RouteParams, RoutePreviousState, PreviousSubscriptionSelector } from '../../../../reducers/selectors/customer.selectors';
import { WorkflowActivityItemsSelector } from '../../../../reducers/selectors/workflow.selectors';
import { AdditionalAttributesForOrder, AllOrderContractsSelector, ConvergentBillerOrderDetailsSelector, ConvergentBillerOrderPaymentInstruments, ConvergentBillerOrderProductIdsSelector, ConvergentBillerOrderServiceDetailsFormattedSelector, ConvergentBillerOrderTransferredSubscriberSelector, CurrentOrderDetailsPaymentInstrumentSelector, CurrentOrderItemDisplayItemsSelector, CurrentOrderItemsBulkStatusViewModelSelector, CurrentOrderItemTransactionSelector, HasOrderDetailTotalsSelector, IsFetchingOrderDetailsSelector, IsFetchingOrderServiceDetailsSelector, ORDER_DETAILS_MORE_MENU_CONSTANTS, OrderContractDetailsSelector, OrderContractExternalContractIdSelector, OrderContractMapSelector, OrderDetailsMoreMenuItemsSelector, OrderDetailsPurchaseOrderNumberSelector, OrderItemToDisplayServiceAttributesFor, OrderServiceDetailsErrorSelector, OrderStoresSelector, OrderWorkflowSummarySelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { BillingEffectiveDateOptionsSelector, BillingEffectiveDateSettingsSelector, CanIssueOrderCreditSelector, CurrentOrderBillingEffectiveDateSelector, CurrentOrderHasShippingAddressSelector, FormattedShippingCityStateSelector, IsDbssOrderSelector, IsGiftRedemptionOrderSelector, IsRetrievingOrderContextSelector, OrderDetailsImportServiceAttributesJobsPendingUpdatedStatusSelector, OrderDetailTabsSelector, SelectedOfferExecutionOptionsSelector, ShowOrderDetailsExecutionDate, EnableOrderDetailsMinimumCommitmentFeatureToggleSelector } from '../../../../reducers/selectors/order.details.selectors';
import { CurrentDetailsGiftOrderInfoSelector, IsResendingGiftNotificationSelector, ResendGiftNotificationErrorSelector, ResendGiftNotificationInfoSelector } from '../../../../reducers/selectors/resend.gift.notification.selectors';
import { retrieveConvergentBillerOrderDetails, setOrderItemToDisplayServiceAttributesFor } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { updateLifeCycleDetails } from '../../../../reducers/actions/customer.actions';
import { cancelOrder, cancelPendingOrder, completeOrder, resubmitOrder, retrieveOrderServiceDetails, searchSubscriberOfferings } from '../../../../reducers/actions/order.actions';
import { CancelOrderErrorSelector, IsCancellingOrderSelector } from '../../../../reducers/selectors/order.history.selectors';
import { getWorkflowActivityInstance } from '../../../../reducers/actions/workflow.actions';
import { clearImportBulkServiceAttributesJobsPendingUpdatedStatus, retrieveOrderContext, setCurrentTab, updateFdoExecutionDate, updateImportBulkServiceAttributesJobsPendingUpdatedStatus } from '../../../../reducers/actions/order.details.actions';
import { resetGiftOrderInfo, setResendGiftOrderInfo, submitResendGiftNotification } from '../../../../reducers/actions/resend.gift.notification.actions';
import { ACTIONS_ITEMS, IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_STATUSES, IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES, ORDER_STATUS, ORDER_TYPES, SUSPEND_RESTORE_TYPE } from './order.details.constants';
import { TRANSACTION_DETAILS_STATE } from '../../transactions/transactions.config';
import { GRANTED_COUPON_ROUTE, COUPON_DETAILS_ROUTE } from '../../coupons/customer.coupons.config';
import { COUPON_DETAILS_GLOBAL_ROUTE } from '../../../couponRedemptionCode/coupon.redemption.code.config';
import { SUBSCRIPTION_DETAILS_ROUTE } from '../../subscriptions/subscriptions.config';
import { DETAIL_STATE_OR_NAME as PRODUCT_STATE } from '../../products/products.config';
import { getProductMetadataBatch } from '../../../../reducers/actions/products.order.actions';
import { BulkChargeTypes } from '../../../wizards/newConnectWizard/new.connect.wizard.constants';
import { returnExpiredImportBulkServiceAttributesJobsPendingUpdatedStatus } from './importBulkAttributesModal/import.bulk.attributes.modal.helper';
import { IsFutureDatedOrderAllowedInBunt, LifeCyclePricingPlanDetailsSelector, PricingPlanInLifeCycleForOffersSelector } from '../../../../reducers/selectors/selected.offering.order.selectors';
import { retrieveCandidateBillCycles } from '../../../../reducers/actions/customer.billcycle.actions';
import { DisconnectReasonForOrderDetailsSelector } from '../../../../reducers/selectors/services.selectors';
import { SERVICES_AND_SHARED_ENTITLEMENTS, SERVICES_AND_SHARED_ENTITLEMENTS_TAB } from '../../servicesAndUsage/services.and.usage.config';
import { CurrentCustomerNodeSelector } from '../../../../reducers/selectors/customer.account.hierarchy.selectors';
import { EDIT_OFFERING_INSTANCES, STATE_OR_NAME as EDIT_OFFERING } from '../../../../reducers/constants/edit.offer.wizard.constants';
import { ADD_OFFERING_INSTANCES, STATE_OR_NAME as ADD_OFFERING } from '../../../../reducers/constants/add.offer.wizard.constants';
import { OFFERING_STATUS_TYPES } from '../../offerings/offerings.constants';
import { ReactOrderItemDetailsToggleSelector, ReactOrderDetailsWorkflowToggleSelector } from '../../../../reducers/selectors/customer.actions.template.selectors';
var OrderDetailsController = /*#__PURE__*/function () {
  function OrderDetailsController($ngRedux, $timeout, uiNotificationService, $filter) {
    _classCallCheck(this, OrderDetailsController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      onCloseAppointmentDetailsModal: this.onCloseAppointmentDetailsModal.bind(this),
      orderItemsWithAppointments: [],
      currentDiscountDetails: null,
      CustomerLocaleKeys: CustomerLocaleKeys,
      onBannerClose: this.onBannerClose.bind(this),
      ORDER_STATUS: ORDER_STATUS,
      ORDER_TYPES: ORDER_TYPES,
      SUSPEND_RESTORE_TYPE: SUSPEND_RESTORE_TYPE,
      showDiscountDetailsPopup: false,
      showAppointmentDetails: false,
      showAppointmentDetailsModal: false,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OrderDetailsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          additionalProperties: AdditionalAttributesForOrder(store),
          allOrderContracts: AllOrderContractsSelector(store),
          areBulkTypesLoaded: MetadataCodeLoadedSelector(CODES.BulkChargeType, store),
          arePeriodTypesLoaded: MetadataCodeLoadedSelector(CODES.PeriodType, store),
          billingEffectiveDateOptions: BillingEffectiveDateOptionsSelector(store),
          billingEffectiveDateSettings: BillingEffectiveDateSettingsSelector(store),
          bulkServiceAttributesJobsPendingUpdatedStatus: OrderDetailsImportServiceAttributesJobsPendingUpdatedStatusSelector(store),
          cancelOrderErrorMessage: CancelOrderErrorSelector(store),
          canIssueOrderCredit: CanIssueOrderCreditSelector(store),
          currentOrderDetailsPaymentInstrumentSelector: CurrentOrderDetailsPaymentInstrumentSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomerNode: CurrentCustomerNodeSelector(store),
          currentOrderBillingEffectiveDate: CurrentOrderBillingEffectiveDateSelector(store),
          currentOrderDetails: ConvergentBillerOrderDetailsSelector(store),
          currentOrderDisplayItems: CurrentOrderItemDisplayItemsSelector(store),
          currentOrderGiftOrderInfo: CurrentDetailsGiftOrderInfoSelector(store),
          currentOrderHasShippingAddress: CurrentOrderHasShippingAddressSelector(store),
          currentOrderId: CurrentOrderIdSelector(store),
          currentOrderItemsBulkStatusesViewModel: CurrentOrderItemsBulkStatusViewModelSelector(store),
          currentOrderPaymentInstruments: ConvergentBillerOrderPaymentInstruments(store),
          currentOrderProductIds: ConvergentBillerOrderProductIdsSelector(store),
          currentOrderServiceDetails: ConvergentBillerOrderServiceDetailsFormattedSelector(store),
          currentOrderTransaction: CurrentOrderItemTransactionSelector(store),
          currentOrderTransferredSubscriber: ConvergentBillerOrderTransferredSubscriberSelector(store),
          disconnectReasonForOrderDetails: DisconnectReasonForOrderDetailsSelector(store),
          executionOptions: SelectedOfferExecutionOptionsSelector(store),
          fdoAllowedInBunt: IsFutureDatedOrderAllowedInBunt(store),
          fdoConfigurationLoaded: MetadataCodeLoadedSelector(CODES.FutureDatedOrderConfiguration, store),
          formattedShippingCityState: FormattedShippingCityStateSelector(store),
          hasOrderDetailTotals: HasOrderDetailTotalsSelector(store),
          isCancellingOrder: IsCancellingOrderSelector(store),
          isDbss: IsDbss(store),
          isDbssOrder: IsDbssOrderSelector(store),
          isFetchingOrderDetails: IsFetchingOrderDetailsSelector(store),
          isFetchingOrderServiceDetails: IsFetchingOrderServiceDetailsSelector(store),
          isGiftRedemptionOrder: IsGiftRedemptionOrderSelector(store),
          isReactOrderItemDetailsEnabled: ReactOrderItemDetailsToggleSelector(store),
          isTotalMinimumCommitmentEnabled: EnableOrderDetailsMinimumCommitmentFeatureToggleSelector(store),
          isReactOrderDetailsWorkflowEnabled: ReactOrderDetailsWorkflowToggleSelector(store),
          isResendingGiftNotification: IsResendingGiftNotificationSelector(store),
          isRetrievingOrderContext: IsRetrievingOrderContextSelector(store),
          isServiceReasonCodeLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          isOrderItemChangeLoaded: MetadataCodeLoadedSelector(CODES.OrderItemChangeType, store),
          lifeCyclePricingPlanDetails: LifeCyclePricingPlanDetailsSelector(store),
          moreMenuItems: OrderDetailsMoreMenuItemsSelector(store),
          offeringMetadataById: OfferingMetadataByIdSelector(store),
          orderContractDetails: OrderContractDetailsSelector(store),
          orderContractsMap: OrderContractMapSelector(store),
          orderContractExternalContractId: OrderContractExternalContractIdSelector(store),
          orderItemToDisplayServiceAttributesFor: OrderItemToDisplayServiceAttributesFor(store),
          orderServiceDetailsError: OrderServiceDetailsErrorSelector(store),
          orderStores: OrderStoresSelector(store),
          previousPageSubscription: PreviousSubscriptionSelector(store),
          pricingPlanInLifeCycleForOffers: PricingPlanInLifeCycleForOffersSelector(store),
          purchaseOrderNumber: OrderDetailsPurchaseOrderNumberSelector(store),
          regexCodes: MetadataCodeTypeSelector(CODES.RegularExpression, store),
          regexCodesLoaded: MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          resendGiftNotificationError: ResendGiftNotificationErrorSelector(store),
          resendGiftNotificationInfo: ResendGiftNotificationInfoSelector(store),
          routeParams: RouteParams(store),
          routePreviousState: RoutePreviousState(store),
          serviceAtrributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          serviceAttributeCodes: MetadataCodeTypeSelector(CODES.ServiceAttribute, store),
          showExecutionDate: ShowOrderDetailsExecutionDate(store),
          storesLoaded: MetadataCodeLoadedSelector(CODES.Stores, store),
          tabs: OrderDetailTabsSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          workflowActivities: WorkflowActivityItemsSelector(store),
          workflows: OrderWorkflowSummarySelector(store)
        };
      };
      var controllerActions = {
        cancelOrder: cancelOrder,
        cancelPendingOrder: cancelPendingOrder,
        clearImportBulkServiceAttributesJobsPendingUpdatedStatus: clearImportBulkServiceAttributesJobsPendingUpdatedStatus,
        completeOrder: completeOrder,
        fetchBulkChargeTypes: function fetchBulkChargeTypes() {
          return fetchCodeTypes(CODES.BulkChargeType);
        },
        fetchCodeTypes: fetchCodeTypes,
        fetchDisconnectReasons: function fetchDisconnectReasons() {
          return fetchCodeTypes(CODES.ReasonCodes);
        },
        fetchOrderItemChangeType: function fetchOrderItemChangeType() {
          return fetchCodeTypes(CODES.OrderItemChangeType);
        },
        fetchFdoConfiguration: function fetchFdoConfiguration() {
          return fetchCodeTypes(CODES.FutureDatedOrderConfiguration);
        },
        fetchPeriodTypes: function fetchPeriodTypes() {
          return fetchCodeTypes(CODES.PeriodType);
        },
        fetchServiceAttributes: fetchServiceAttributes,
        fetchWorkflowActivityStates: function fetchWorkflowActivityStates() {
          return fetchCodeTypes(CODES.WorkflowActivityState);
        },
        fetchObriConfig: function fetchObriConfig() {
          return fetchCodeTypes(CODES.OneTimeBillerRuleConfiguration);
        },
        fetchRbriConfig: function fetchRbriConfig() {
          return fetchCodeTypes(CODES.RecurringBillerRuleConfiguration);
        },
        getProductMetadataBatch: getProductMetadataBatch,
        getWorkflowActivityInstance: getWorkflowActivityInstance,
        resetGiftOrderInfo: resetGiftOrderInfo,
        resubmitOrder: resubmitOrder,
        retrieveCandidateBillCycles: retrieveCandidateBillCycles,
        retrieveConvergentBillerOrderDetails: retrieveConvergentBillerOrderDetails,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderContext: retrieveOrderContext,
        retrieveOrderServiceDetails: retrieveOrderServiceDetails,
        searchSubscriberOfferings: searchSubscriberOfferings,
        setCurrentTab: setCurrentTab,
        setOrderItemToDisplayServiceAttributesFor: setOrderItemToDisplayServiceAttributesFor,
        setResendGiftOrderInfo: setResendGiftOrderInfo,
        stateGo: stateGo,
        stateReload: stateReload,
        submitResendGiftNotification: submitResendGiftNotification,
        updateFdoExecutionDate: updateFdoExecutionDate,
        updateImportBulkServiceAttributesJobsPendingUpdatedStatus: updateImportBulkServiceAttributesJobsPendingUpdatedStatus,
        updateLifeCycleDetails: updateLifeCycleDetails
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = 'index.customercare.customer.orderDetails';
      this.optionalParams = {
        customerId: this.state.currentCustomerId,
        currentOrderId: this.state.currentOrderId
      };
      this.displayBulkOrderStatus = function (item) {
        return item.IsBulkWithServices && item.BulkExtractItemDetail && item.BulkExtractItemDetail.BulkExportStatus !== IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES.NOT_STARTED;
      };
      this.enableRefreshStatusLink = function (item) {
        var isPendingUpdatedStatus = _this.bulkServiceAttributesJobIsPendingUpdatedStatus(item.pricingPlanId);
        return item.BulkExtractItemDetail && IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_PENDING_STATUSES.includes(item.BulkExtractItemDetail.BulkExportStatus) || isPendingUpdatedStatus;
      };
      this.displayOrderItemWorkflowStatus = function (item) {
        return !!item.WorkflowInstanceId && !item.IsBulkWithServices;
      };
      this.summaryTabs = [{
        active: false,
        id: 1,
        glyph: 'credit-card-alt',
        title: this.CustomerLocaleKeys.ORDER_DETAILS.PAYMENT_SUMMARY
      }, {
        active: false,
        id: 2,
        glyph: 'truck',
        title: this.CustomerLocaleKeys.ORDER_DETAILS.SHIPPING_SUMMARY
      }];
      this.actions.setCurrentTab(1);
      if (!this.state.areBulkTypesLoaded) {
        this.actions.fetchBulkChargeTypes();
      }
      if (!this.state.arePeriodTypesLoaded) {
        this.actions.fetchPeriodTypes();
      }
      if (!this.state.storesLoaded) {
        this.actions.fetchCodeTypes(CODES.Stores);
      }
      if (!this.state.fdoConfigurationLoaded) {
        this.actions.fetchFdoConfiguration();
      }
      if (this.state.isDbss) {
        this.actions.retrieveCandidateBillCycles(this.state.currentCustomerId, SubscriberOrderTypeEnum.postpaid.value);
      }
      if (!this.state.isServiceReasonCodeLoaded) {
        this.actions.fetchDisconnectReasons();
      }
      if (!this.state.isOrderItemChangeLoaded) {
        this.actions.fetchOrderItemChangeType();
      }
      this.actions.fetchServiceAttributes();
      this.actions.fetchWorkflowActivityStates();
      this.actions.retrieveConvergentBillerOrderDetails(this.state.currentCustomerId, this.state.currentOrderId).then(function (response) {
        _this.actions.getProductMetadataBatch(_this.state.currentOrderProductIds);
        var offeringId = response.Order.Items[0].OfferingId;
        _this.showAppointmentDetails = !!(response.Order.Items || []).filter(function (_ref) {
          var AppointmentReservations = _ref.AppointmentReservations;
          return AppointmentReservations === null || AppointmentReservations === void 0 ? void 0 : AppointmentReservations.length;
        }).length;
        if (!_this.state.offeringMetadataById[offeringId] && offeringId) {
          _this.actions.fetchObriConfig();
          _this.actions.fetchRbriConfig();
          _this.actions.retrieveOfferingsMetadata([offeringId]);
        }
        // this call depends on the order details being filled out
        if (_this.state.currentOrderDetails.Workflows.length) {
          _this.actions.getWorkflowActivityInstance(_this.state.currentOrderDetails.Workflows.map(function (wf) {
            return wf.Id;
          }));
        }
        if (_this.state.isGiftRedemptionOrder) {
          _this.summaryTabs.splice(0, 1);
          if (!_this.state.currentOrderHasShippingAddress) {
            _this.summaryTabs.splice(0, 1);
          }
        } else {
          if (!_this.state.currentOrderHasShippingAddress) {
            _this.summaryTabs.splice(1, 1);
          }
          if (!_this.state.currentOrderDetailsPaymentInstrumentSelector.length) {
            _this.summaryTabs.splice(0, 1);
          }
        }
        if (_this.summaryTabs.length > 0) {
          _this.summaryTabs[0].active = true;
        }
      });
      this.actions.retrieveOrderServiceDetails(this.state.currentOrderId, this.state.currentCustomerId);
      this.canViewTransactionDetails = hasReadAccess(this.state.userSecurityAttributes, PAYMENT_ACTIVITY_VIEW_ACCESS.id);
      this.additionalPropertiesModalConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.additionalPropertiesModalAPI = api;
        }
      };
      this.applyCreditModalConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this.applyCreditModalApi = api;
        }
      };
      this.attributeModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.attributeModalAPI = event.api;
        }
      };
      this.exportBulkServiceAttributesModalConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this.exportBulkServiceAttributesModalApi = api;
        }
      };
      this.bulkDetailsConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this.bulkDetailsApi = api;
        }
      };
      this.cancelOrderModalConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this.cancelOrderModalApi = api;
        }
      };
      this.completeOrderConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this.completeOrderApi = api;
        }
      };
      this.instancePropertiesModalConfig = {
        onRegisterApi: function onRegisterApi(_ref8) {
          var api = _ref8.api;
          _this.instancePropertiesModalAPI = api;
        }
      };
      this.resendGiftNotificationModalConfig = {
        onRegisterApi: function onRegisterApi(_ref9) {
          var api = _ref9.api;
          _this.resendGiftNotificationModalApi = api;
        }
      };
      this.resubmitConfirmationConfig = {
        onRegisterApi: function onRegisterApi(_ref10) {
          var api = _ref10.api;
          _this.resubmitConfirmationApi = api;
        }
      };
      this.revokeGiftOrderPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref11) {
          var api = _ref11.api;
          _this.revokeGiftOrderPopupApi = api;
        }
      };
      this.importBulkServiceAttributesModalConfig = {
        modal: true,
        onRegisterApi: function onRegisterApi(_ref12) {
          var api = _ref12.api;
          _this.importBulkServiceAttributesModalApi = api;
        }
      };
      this.lifeCycleDetailsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref13) {
          var api = _ref13.api;
          _this.lifeCycleDetailsPopupConfigApi = api;
        }
      };
      this.contractTermsConditionsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.contractTermsConditionsPopupApi = event.api;
        }
      };
      this.openContractTermsConditionsPopup = function (contract) {
        if (contract) {
          _this.selectedContractId = contract.OrderContractId;
        }
        _this.contractTermsConditionsPopupOpened = true;
        _this.$timeout(function () {
          _this.contractTermsConditionsPopupApi.open();
        });
      };
      this.handleCloseContractTermsConditionsPopup = function () {
        _this.contractTermsConditionsPopupApi.close();
        _this.contractTermsConditionsPopupOpened = false;
        _this.selectedContractId = null;
      };
      this.changeFdoDatePopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.changeFdoDatePopupApi = event.api;
        }
      };
      this.discountDetailsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.discountDetailsPopupApi = event.api;
        }
      };
      this.handleChangeFdoDatePopup = function () {
        _this.changeFdoDatePopupApi.close();
        _this.changeFdoDatePopupOpened = false;
      };
      this.backBannerInfo = this.createBannerInfo();
      this.shouldShowBackBanner = this.backBannerInfo[this.state.routePreviousState.name];
      this.contractsTooltipTemplate = require('./contracts.tooltip.template.html');
      this.selectedContractId = null;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearImportBulkServiceAttributesJobsPendingUpdatedStatus();
      this.disconnectRedux();
    }
  }, {
    key: "isBillingEffectiveDateShown",
    value: function isBillingEffectiveDateShown() {
      return hasAccess(this.state.userSecurityAttributes, OVERRIDE_BILLING_EFFECTIVE_DATE) && this.state.currentOrderDetails.FutureDatedOrder;
    }
  }, {
    key: "openLifeCycleDetailsPopup",
    value: function openLifeCycleDetailsPopup(option, savedLifeCycleId) {
      var _this2 = this;
      this.actions.updateLifeCycleDetails({
        offerId: option.OfferingId,
        lifeCycleId: savedLifeCycleId
      });
      this.pricingPlanInLifeCycleForOffers = this.state.pricingPlanInLifeCycleForOffers;
      this.lifeCyclePricingPlanDetails = Object.assign.apply(Object, [{}].concat(_toConsumableArray(this.state.lifeCyclePricingPlanDetails)));
      this.lifeCycleDialogOpened = true;
      this.currentLifeCycle = option.pricingPlanId;
      this.$timeout(function () {
        _this2.lifeCycleDetailsPopupConfigApi.open();
      });
    }
  }, {
    key: "closeLifeCycleDetailsPopup",
    value: function closeLifeCycleDetailsPopup() {
      this.lifeCycleDialogOpened = false;
      this.lifeCycleDetailsPopupConfigApi.close();
    }
  }, {
    key: "openFutureDatedOrderPopup",
    value: function openFutureDatedOrderPopup() {
      var _this3 = this;
      this.changeFdoDatePopupOpened = true;
      this.$timeout(function () {
        _this3.changeFdoDatePopupApi.open();
      });
    }
  }, {
    key: "openDiscountDetailsPopup",
    value: function openDiscountDetailsPopup(item) {
      var _this4 = this;
      this.currentDiscountDetails = item.Discounts;
      this.showDiscountDetailsPopup = true;
      this.$timeout(function () {
        _this4.discountDetailsPopupApi.open();
      });
    }
  }, {
    key: "closeDiscountDetailsPopup",
    value: function closeDiscountDetailsPopup() {
      this.showDiscountDetailsPopup = false;
      this.discountDetailsPopupApi.close();
    }
  }, {
    key: "openChangeFdoDatePopup",
    value: function openChangeFdoDatePopup(isBillingEffectiveDateClick) {
      var _this5 = this;
      if (this.state.fdoAllowedInBunt && this.state.showExecutionDate) {
        if (this.isBillingEffectiveDateShown()) {
          this.actions.retrieveOrderContext(this.state.currentOrderDetails).then(function () {
            _this5.openFutureDatedOrderPopup();
          }).catch(function (error) {
            _this5.uiNotificationService.transientError(error.translatedMessage);
          });
        } else if (!isBillingEffectiveDateClick) {
          this.openFutureDatedOrderPopup();
        }
      }
    }
  }, {
    key: "handleActionItemsSelected",
    value: function handleActionItemsSelected(selectedItem, actionsItem) {
      switch (actionsItem.item.id) {
        case ACTIONS_ITEMS.IMPORT_SERVICE_ATTRIBUTES_ID:
          this.openImportBulkServiceAttributesModal(selectedItem);
          break;
        case ACTIONS_ITEMS.VIEW_APPOINTMENT_DETAILS:
          this.onOpenAppointmentDetailsModal(selectedItem.Id);
          break;
        case ACTIONS_ITEMS.VIEW_PRICING_SCHEDULE_ID:
          this.openBulkDetailsModal(selectedItem);
          break;
        case ACTIONS_ITEMS.VIEW_SERVICES_ATTRIBUTES_ID:
          this.openServiceAttributes(selectedItem);
          break;
        case ACTIONS_ITEMS.VIEW_SERVICES_ID:
          this.openBulkServices(selectedItem);
          break;
        case ACTIONS_ITEMS.EXPORT_SERVICES_TEMPLATE_ID:
          this.openExportBulkServiceAttributesModal(selectedItem);
          break;
        default:
          break;
      }
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(selectedItem) {
      switch (selectedItem.item.id) {
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.CANCEL_ORDER:
          this.openCancelOrderModal();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.COMPLETE_ORDER:
          this.openCompleteOrderModal();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.CREDIT_ORDER:
          this.openCreditModal();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.RESEND_GIFT_NOTIFICATION:
          this.openResendGiftNotificationModal();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.RESUBMIT_ORDER:
          this.openResubmitConfirmation();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.REVOKE_GIFT:
          this.openRevokeGiftOrderModal();
          break;
        case ORDER_DETAILS_MORE_MENU_CONSTANTS.EDIT_ORDER:
          this.navigateToFdoWizard();
          break;
        default:
          break;
      }
    }
  }, {
    key: "openCompleteOrderModal",
    value: function openCompleteOrderModal() {
      this.showCompleteOrder = true;
      this.$timeout(this.completeOrderApi.open);
    }
  }, {
    key: "closeCompleteOrderModal",
    value: function closeCompleteOrderModal() {
      this.showCompleteOrder = false;
      this.completeOrderApi.close();
    }
  }, {
    key: "handleCompleteOrderResult",
    value: function handleCompleteOrderResult(result) {
      var _this6 = this;
      this.closeCompleteOrderModal();
      if (result) {
        this.actions.completeOrder(this.state.currentCustomerId, this.state.currentOrderId).then(function () {
          _this6.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.COMPLETE_ORDER_SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }).catch(function (payload) {
          _this6.uiNotificationService.error(payload.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
      }
    }
  }, {
    key: "closeAdditionalPropertiesModal",
    value: function closeAdditionalPropertiesModal() {
      this.additionalPropertiesModalAPI.close();
      this.showAdditionalPropertiesModal = false;
    }
  }, {
    key: "closeInstancePropertiesModal",
    value: function closeInstancePropertiesModal() {
      this.instancePropertiesModalAPI.close();
      this.showInstancePropertiesModal = false;
    }
  }, {
    key: "closeAttributeModal",
    value: function closeAttributeModal() {
      this.attributeModalAPI.close();
      this.showAttributeModal = false;
    }
  }, {
    key: "onTabSelection",
    value: function onTabSelection(tab) {
      this.actions.setCurrentTab(this.state.tabs.indexOf(tab) + 1);
    }
  }, {
    key: "onSummaryTabSelection",
    value: function onSummaryTabSelection(tab) {
      this.summaryTabs.forEach(function (t) {
        t.active = t === tab;
      });
    }
  }, {
    key: "handleCancelOrderModalResult",
    value: function handleCancelOrderModalResult(cancel) {
      var _this7 = this;
      this.cancelOrderModalApi.close();
      this.showCancelOrderModal = false;
      if (cancel) {
        Promise.resolve().then(function () {
          return _this7.state.currentOrderDetails.FutureDatedOrder ? _this7.actions.cancelPendingOrder(_this7.state.currentCustomerId, _this7.state.currentOrderId) : _this7.actions.cancelOrder(_this7.state.currentCustomerId, _this7.state.currentOrderId, true);
        }).then(function () {
          _this7.uiNotificationService.success(i18n.translate(_this7.CustomerLocaleKeys.ORDER_CANCELED_SUCCESSFULLY), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this7.actions.retrieveConvergentBillerOrderDetails(_this7.state.currentCustomerId, _this7.state.currentOrderId);
          _this7.actions.retrieveOrderServiceDetails(_this7.state.currentOrderId, _this7.state.currentCustomerId);
        }).catch(function (payload) {
          _this7.uiNotificationService.error(payload.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
      }
    }
  }, {
    key: "closeBulkDetailsModal",
    value: function closeBulkDetailsModal() {
      this.bulkDetailsApi.close();
      delete this.selectedBulkOrder;
    }
  }, {
    key: "openRevokeGiftOrderModal",
    value: function openRevokeGiftOrderModal() {
      var _this8 = this;
      this.showRevokeGiftOrderDialog = true;
      this.$timeout(function () {
        _this8.revokeGiftOrderPopupApi.open();
      });
    }
  }, {
    key: "redirectToFdoWizard",
    value: function redirectToFdoWizard(offeringId, offeringInstanceId) {
      if (this.state.currentOrderDetails.Type === ORDER_TYPES.NEW) {
        var _this$state$currentOr, _this$state$currentOr2;
        this.actions.stateGo(this.state.currentOrderDetails.InstanceLevelOrdered ? ADD_OFFERING_INSTANCES : ADD_OFFERING, {
          futureDatedOrderId: this.state.currentOrderDetails.Id,
          futureDatedOfferingId: offeringId,
          pId: (_this$state$currentOr = this.state.currentOrderPaymentInstruments) === null || _this$state$currentOr === void 0 ? void 0 : (_this$state$currentOr2 = _this$state$currentOr[0]) === null || _this$state$currentOr2 === void 0 ? void 0 : _this$state$currentOr2.Id
        });
      }
      if (this.state.currentOrderDetails.Type === ORDER_TYPES.CHANGE_OF_SERVICE) {
        var _this$state$currentOr3, _this$state$currentOr4;
        this.actions.stateGo(this.state.currentOrderDetails.InstanceLevelOrdered ? EDIT_OFFERING_INSTANCES : EDIT_OFFERING, {
          offeringId: offeringId,
          offeringInstanceId: offeringInstanceId,
          futureDatedOrderId: this.state.currentOrderDetails.Id,
          pId: (_this$state$currentOr3 = this.state.currentOrderPaymentInstruments) === null || _this$state$currentOr3 === void 0 ? void 0 : (_this$state$currentOr4 = _this$state$currentOr3[0]) === null || _this$state$currentOr4 === void 0 ? void 0 : _this$state$currentOr4.Id
        });
      }
    }
  }, {
    key: "navigateToFdoWizard",
    value: function navigateToFdoWizard() {
      var _find,
        _this$state$currentOr5,
        _find2,
        _this$state$currentOr6,
        _this9 = this;
      var currentOfferingInstanceId = (_find = (((_this$state$currentOr5 = this.state.currentOrderDetails) === null || _this$state$currentOr5 === void 0 ? void 0 : _this$state$currentOr5.Items) || []).find(function (orderItem) {
        return orderItem.OfferingInstanceId;
      })) === null || _find === void 0 ? void 0 : _find.OfferingInstanceId;
      var currentOrderOfferingId = (_find2 = (((_this$state$currentOr6 = this.state.currentOrderDetails) === null || _this$state$currentOr6 === void 0 ? void 0 : _this$state$currentOr6.Items) || []).find(function (orderItem) {
        return orderItem.OfferingId;
      })) === null || _find2 === void 0 ? void 0 : _find2.OfferingId;
      if (currentOrderOfferingId) {
        this.redirectToFdoWizard(currentOrderOfferingId, currentOfferingInstanceId);
      } else {
        /**
         * Service feature only FDO. OfferingId will not be available on RetrieveOrder items.
         * We need to call searchSubscriberOfferings to get offeringId using offeringInstanceId
         */
        this.actions.searchSubscriberOfferings({
          customerId: this.state.routeParams.customerId,
          status: [OFFERING_STATUS_TYPES.ACTIVE, OFFERING_STATUS_TYPES.PENDING_ACTIVE, OFFERING_STATUS_TYPES.PENDING_REMOVED, OFFERING_STATUS_TYPES.PENDING_TRANSFER, OFFERING_STATUS_TYPES.SUSPENSION_SCHEDULED],
          offeringInstanceIds: [currentOfferingInstanceId]
        }).then(function (response) {
          var _find3;
          currentOrderOfferingId = (_find3 = (response.SubscriberOfferings || []).find(function (offering) {
            return offering.OfferingInstanceId === currentOfferingInstanceId;
          })) === null || _find3 === void 0 ? void 0 : _find3.OfferingId;
          _this9.redirectToFdoWizard(currentOrderOfferingId, currentOfferingInstanceId);
        }).catch(function (error) {
          _this9.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "closeRevokeGiftOrderModal",
    value: function closeRevokeGiftOrderModal() {
      this.showRevokeGiftOrderDialog = false;
      this.revokeGiftOrderPopupApi.close();
    }
  }, {
    key: "handleSuccessRevokeGiftOrderDialog",
    value: function handleSuccessRevokeGiftOrderDialog() {
      this.actions.retrieveConvergentBillerOrderDetails(this.state.currentCustomerId, this.state.currentOrderId);
      this.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.REVOKE_GIFT_SUCCESS), null, {
        timeOut: NOTIFICATION_TIME_LENGTH
      });
      this.revokeGiftOrderPopupApi.close();
    }
  }, {
    key: "handleWorkflowExpansion",
    value: function handleWorkflowExpansion(workflow) {
      workflow.isExpanded = !workflow.isExpanded;
    }
  }, {
    key: "openCancelOrderModal",
    value: function openCancelOrderModal() {
      this.showCancelOrderModal = true;
      this.cancelOrderTitle = i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.ARE_YOU_SURE_YOU_WANT_TO_CANCEL_ORDER, {
        Id: this.state.currentOrderDetails.OrderNumber
      });
      this.$timeout(this.cancelOrderModalApi.open);
    }
  }, {
    key: "openBulkDetailsModal",
    value: function openBulkDetailsModal(item) {
      this.selectedBulkOrder = item;
      this.$timeout(this.bulkDetailsApi.open);
    }
  }, {
    key: "openBulkServices",
    value: function openBulkServices(item) {
      this.actions.stateGo(SERVICES_AND_SHARED_ENTITLEMENTS, {
        tabName: SERVICES_AND_SHARED_ENTITLEMENTS_TAB.SERVICES,
        orderItemId: item.Id,
        orderId: this.state.currentOrderDetails.Id
      });
    }
  }, {
    key: "openAdditionalProperties",
    value: function openAdditionalProperties() {
      this.additionalPropertyModalContentTitle = i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.ORDER_NUMBER_TITLE, {
        orderNumber: this.state.currentOrderDetails.OrderNumber
      });
      this.showAdditionalPropertiesModal = true;
      this.$timeout(this.additionalPropertiesModalAPI.open);
    }
  }, {
    key: "openInstancePropertiesDialog",
    value: function openInstancePropertiesDialog(item) {
      var _this10 = this;
      this.instancePropertyModalContentTitle = item.displayName;
      this.orderItemOfInterest = {
        instanceProperties: {}
      };
      forEachObjIndexed(function (value, keyLabel) {
        if (keyLabel.match(/Date/i)) {
          _this10.orderItemOfInterest.instanceProperties[keyLabel] = _this10.$filter('date')(value, 'shortDate');
        } else {
          _this10.orderItemOfInterest.instanceProperties[keyLabel] = value;
        }
      }, item.instanceProperties);
      this.showInstancePropertiesModal = true;
      this.$timeout(this.instancePropertiesModalAPI.open);
    }
  }, {
    key: "openServiceAttributes",
    value: function openServiceAttributes(item) {
      var orderItem = this.state.currentOrderServiceDetails[this.state.currentOrderId].filter(function (orderItem) {
        return orderItem.OrderItemId === item.Id;
      })[0];
      this.editAttributes = orderItem.ServiceAttributeValues;
      this.availableAttributes = orderItem.AvailableServiceAttributes;
      this.orderItemId = orderItem.OrderItemId;
      this.attributeModalContentTitle = item.displayName;
      this.showAttributeModal = true;
      this.$timeout(this.attributeModalAPI.open);
    }
  }, {
    key: "openExportBulkServiceAttributesModal",
    value: function openExportBulkServiceAttributesModal(orderItem) {
      this.currentOrderBulkServicesDetails = {
        customerId: this.state.currentCustomerId,
        jobId: pathOr(null, ['BulkExtractDetail', 'Id'], this.state.currentOrderDetails),
        offeringId: orderItem.OfferingId,
        orderId: this.state.currentOrderDetails.Id,
        pricingPlanId: orderItem.pricingPlanId,
        pricingPlanName: orderItem.displayName
      };
      this.showExportBulkServiceAttributesModal = true;
      this.$timeout(this.exportBulkServiceAttributesModalApi.open);
    }
  }, {
    key: "closeExportBulkServiceAttributesModal",
    value: function closeExportBulkServiceAttributesModal() {
      this.showExportBulkServiceAttributesModal = false;
      this.exportBulkServiceAttributesModalApi.close();
    }
  }, {
    key: "workflowActivityForItem",
    value: function workflowActivityForItem(item) {
      return pathOr(null, ['workflowActivities', item.WorkflowInstanceId, 'workflowInstance', 'activities', 0], this.state);
    }
  }, {
    key: "getItemMatchingWorkflow",
    value: function getItemMatchingWorkflow(workflow) {
      var item = this.state.currentOrderDetails.Items.find(function (orderItem) {
        return orderItem.WorkflowInstanceId && orderItem.WorkflowInstanceId === workflow.Id;
      });
      return item || null;
    }
  }, {
    key: "openResendGiftNotificationModal",
    value: function openResendGiftNotificationModal() {
      this.actions.setResendGiftOrderInfo(this.state.currentOrderGiftOrderInfo);
      this.$timeout(this.resendGiftNotificationModalApi.open);
    }
  }, {
    key: "closeResendGiftNotificationModal",
    value: function closeResendGiftNotificationModal() {
      this.actions.resetGiftOrderInfo();
      this.resendGiftNotificationModalApi.close();
    }
  }, {
    key: "submitResendGiftNotificationModal",
    value: function submitResendGiftNotificationModal(giftOrderInfo) {
      var _this11 = this;
      this.actions.submitResendGiftNotification(giftOrderInfo).then(function () {
        _this11.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.RESEND_SUCCESS), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
        _this11.actions.retrieveConvergentBillerOrderDetails(_this11.state.currentCustomerId, _this11.state.currentOrderId);
        _this11.closeResendGiftNotificationModal();
      });
    }
  }, {
    key: "editResendGiftNotificationModal",
    value: function editResendGiftNotificationModal(giftOrderInfo) {
      this.actions.setResendGiftOrderInfo(giftOrderInfo);
    }
  }, {
    key: "openResubmitConfirmation",
    value: function openResubmitConfirmation() {
      this.showResubmitConfirmation = true;
      this.$timeout(this.resubmitConfirmationApi.open);
    }
  }, {
    key: "onResubmitOrderConfirmationResponse",
    value: function onResubmitOrderConfirmationResponse(response) {
      var _this12 = this;
      this.showResubmitConfirmation = false;
      this.resubmitConfirmationApi.close();
      if (response) {
        this.actions.resubmitOrder(this.state.currentCustomerId, this.state.currentOrderId).then(function () {
          _this12.uiNotificationService.success(i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.RESUBMIT_ORDER_SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        }).catch(function (payload) {
          _this12.uiNotificationService.error(payload.translatedMessage, null, {
            timeout: NOTIFICATION_TIME_LENGTH
          });
        });
      }
    }
  }, {
    key: "closeCreditModal",
    value: function closeCreditModal() {
      this.showCreditModal = false;
      this.applyCreditModalApi.close();
    }
  }, {
    key: "onCreditSubmission",
    value: function onCreditSubmission() {
      var _this13 = this;
      this.actions.retrieveConvergentBillerOrderDetails(this.state.currentCustomerId, this.state.currentOrderId);
      this.closeCreditModal();
      this.actions.stateReload().then(function () {
        _this13.showLoadingIndicator = false;
      });
    }
  }, {
    key: "openCreditModal",
    value: function openCreditModal(item) {
      this.additionalApiData = {
        OrderId: this.state.currentOrderDetails.Id
      };
      if (item) {
        this.additionalApiData.OrderItemId = item.Id;
        this.creditMaxAmount = !isNil(item.ReturnAmount) ? item.Amount + item.ReturnAmount : item.Amount;
        this.creditModalTitle = i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.CREDIT.ORDER_ITEM_TITLE, {
          itemName: item.displayName
        });
      } else {
        this.creditMaxAmount = this.maxOrderCreditAmount;
        this.creditModalTitle = i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.CREDIT.ORDER_NUMBER_TITLE, {
          orderNumber: this.state.currentOrderDetails.OrderNumber
        });
      }
      this.showCreditModal = true;
      this.$timeout(this.applyCreditModalApi.open);
    }
  }, {
    key: "onCloseAppointmentDetailsModal",
    value: function onCloseAppointmentDetailsModal() {
      this.showAppointmentDetailsModal = false;
      this.orderItemsWithAppointments = [];
    }
  }, {
    key: "onOpenAppointmentDetailsModal",
    value: function onOpenAppointmentDetailsModal(orderItemId) {
      this.orderItemsWithAppointments = orderItemId ? this.state.currentOrderDetails.Items.filter(function (_ref14) {
        var Id = _ref14.Id;
        return orderItemId === Id;
      }) : this.state.currentOrderDetails.Items;
      this.showAppointmentDetailsModal = true;
    }
  }, {
    key: "onBannerClose",
    value: function onBannerClose() {
      this.shouldShowBackBanner = false;
    }
  }, {
    key: "backBannerText",
    value: function backBannerText() {
      return this.backBannerInfo[this.state.routePreviousState.name](this.state);
    }
  }, {
    key: "subscriptionSecondaryNavigationLabel",
    value: function subscriptionSecondaryNavigationLabel(state) {
      var previousName = state.previousPageSubscription.offeringThumbnail ? state.previousPageSubscription.offeringThumbnail.Name : state.previousPageSubscription.Items[0].Product.Name;
      return i18n.translate(CustomerLocaleKeys.TRANSACTIONS.RETURN_TO, {
        previousName: previousName
      });
    }
  }, {
    key: "maxOrderCreditAmount",
    get: function get() {
      return pathOr(0, ['state', 'currentOrderTransaction', 'PurchaseOrder', 'Totals', 'TotalCreditableAmount'], this);
    }
  }, {
    key: "externalContractIds",
    get: function get() {
      var ids = (this.state.allOrderContracts || []).filter(function (c) {
        return c && c.ExternalContractId;
      }).map(function (c) {
        return c.ExternalContractId;
      }).join(', ');
      return ids || i18n.translate(CustomerLocaleKeys.EMPTY_VALUE_NA);
    }
  }, {
    key: "getContractsTooltipText",
    value: function getContractsTooltipText() {
      return i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.CONTRACTS, {
        count: (this.state.allOrderContracts || []).length
      });
    }
  }, {
    key: "getOrderHistoryHeading",
    value: function getOrderHistoryHeading(item) {
      return item.OfferingName || i18n.translate(CustomerLocaleKeys.PRODUCT);
    }
  }, {
    key: "getOrderSuspensionTypeLabel",
    value: function getOrderSuspensionTypeLabel(suspendRestoreType) {
      if (suspendRestoreType === SUSPEND_RESTORE_TYPE.NETWORK) {
        return i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.SUSPENSION_TYPE_NETWORK);
      }
      if (suspendRestoreType === SUSPEND_RESTORE_TYPE.NETWORK_AND_BILLING) {
        return i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.SUSPENSION_TYPE_NETWORK_AND_BILLING);
      }
      return '';
    }
  }, {
    key: "getMinimumCommitmentForItem",
    value: function getMinimumCommitmentForItem(item) {
      if (!item || !this.state.currentOrderDetails) {
        return null;
      }
      var orderPriceCommitments = this.state.currentOrderDetails.OrderPriceCommitments;
      if (!(orderPriceCommitments !== null && orderPriceCommitments !== void 0 && orderPriceCommitments.length)) {
        return null;
      }
      // Filter commitment by OfferingInstanceId, then fallback to OfferingId
      var commitment = orderPriceCommitments.find(function (c) {
        var _c$OfferingId;
        return c.OfferingInstanceId ? c.OfferingInstanceId === item.OfferingInstanceId : ((_c$OfferingId = c.OfferingId) === null || _c$OfferingId === void 0 ? void 0 : _c$OfferingId.Value) === item.OfferingId;
      });
      return commitment ? {
        amount: commitment.Amount || null,
        currency: this.state.currentOrderDetails.Currency
      } : null;
    }
  }, {
    key: "createBannerInfo",
    value: function createBannerInfo() {
      var info = {};
      info[SUBSCRIPTION_DETAILS_ROUTE] = this.subscriptionSecondaryNavigationLabel;
      info[GRANTED_COUPON_ROUTE] = function () {
        return i18n.translate(CustomerLocaleKeys.COUPONS.RETURN_TO_GRANTED_COUPONS);
      };
      info[TRANSACTION_DETAILS_STATE] = function () {
        return i18n.translate(CustomerLocaleKeys.TRANSACTION_DETAILS.RETURN_TO_TRANSACTION_DETAILS);
      };
      info[COUPON_DETAILS_ROUTE] = function () {
        return i18n.translate(CustomerLocaleKeys.COUPONS.RETURN_TO_COUPON_DETAILS);
      };
      info[COUPON_DETAILS_GLOBAL_ROUTE] = function () {
        return i18n.translate(CustomerLocaleKeys.COUPONS.RETURN_TO_COUPON_DETAILS);
      };
      info[PRODUCT_STATE] = function () {
        return i18n.translate(CustomerLocaleKeys.ORDER_DETAILS.RETURN_TO_PRODUCT_DETAILS);
      };
      return info;
    }
  }, {
    key: "bulkServiceAttributesJobIsPendingUpdatedStatus",
    value: function bulkServiceAttributesJobIsPendingUpdatedStatus(pricingPlanId) {
      return !!this.state.bulkServiceAttributesJobsPendingUpdatedStatus[pricingPlanId];
    }
  }, {
    key: "openImportBulkServiceAttributesModal",
    value: function openImportBulkServiceAttributesModal(orderItem) {
      this.currentOrderBulkServicesDetails = {
        customerId: this.state.currentCustomerId,
        jobId: pathOr(null, ['BulkExtractDetail', 'Id'], this.state.currentOrderDetails),
        offeringId: orderItem.OfferingId,
        orderId: this.state.currentOrderDetails.Id,
        pricingPlanId: orderItem.pricingPlanId,
        pricingPlanName: orderItem.displayName || orderItem.pricingPlanName
      };
      this.showImportBulkServiceAttributesModal = true;
      this.$timeout(this.importBulkServiceAttributesModalApi.open);
    }
  }, {
    key: "closeImportBulkServiceAttributesModal",
    value: function closeImportBulkServiceAttributesModal() {
      this.showImportBulkServiceAttributesModal = false;
      this.importBulkServiceAttributesModalApi.close();
    }
  }, {
    key: "refreshItemForBulkOrderStatus",
    value: function refreshItemForBulkOrderStatus(item) {
      var _this14 = this;
      if (this.enableRefreshStatusLink(item)) {
        this.actions.retrieveConvergentBillerOrderDetails(this.state.currentCustomerId, this.state.currentOrderId).then(function () {
          var jobsToBeRemoved = returnExpiredImportBulkServiceAttributesJobsPendingUpdatedStatus(_this14.state.currentOrderDisplayItems, _this14.state.bulkServiceAttributesJobsPendingUpdatedStatus);
          _this14.actions.updateImportBulkServiceAttributesJobsPendingUpdatedStatus(jobsToBeRemoved);
        });
      }
    }
  }, {
    key: "handleSuccessChangeFdo",
    value: function handleSuccessChangeFdo() {
      var _this15 = this;
      this.actions.updateFdoExecutionDate(this.state.executionOptions, this.state.currentOrderId).then(function () {
        _this15.handleChangeFdoDatePopup();
        _this15.showLoadingIndicator = true;
        _this15.actions.stateReload().then(function () {
          _this15.showLoadingIndicator = false;
        });
      }).catch(function (error) {
        _this15.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "openGroupOrderDetailsInNewWindow",
    value: function openGroupOrderDetailsInNewWindow() {
      NewWindow.open('index.customercare.customer.orderHistory.groupOrderDetails', {
        groupOrderId: this.state.currentOrderDetails.GroupOrderId,
        customerId: this.state.currentCustomerNode.ParentSubscriberId
      });
    }
  }]);
}();
export default {
  template: require('./order.details.html'),
  controller: OrderDetailsController,
  controllerAs: 'OrderDetails'
};